import { styled } from "styled-components";

export const CloseBtnBox = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px;
`;
